import React from "react";
import { Spinner } from "@/Components/Common/Tailwind";

/**
 * Centered loading spinner component
 * @param {{ height?: string }} props
 */
export const LoadingSpinner = ({ height = "50vh" }) => {
  return (
    <div
      className="flex justify-center items-center"
      style={{ height }}
    >
      <Spinner />
    </div>
  );
};

export default LoadingSpinner;
